import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ModalPlugin from './plugins/modal'
import './assets/css/reset.css';
import './assets/css/fontSize.min.css';
import './assets/css/common.css';

Vue.config.productionTip = false

// 注册弹窗插件
Vue.use(ModalPlugin)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

